<template>
  <div :id="`table-${name || 'company'}`">
    <div class="d-flex justify-content-between flex-sm-row flex-column">
      <h1 class="text-secondary">{{ name }}</h1>
      <div class="pt-2" v-if="showCreate">
        <button type="button" class="btn btn-primary" @click="$emit('create')" data-id="create">
          Create {{ name.slice(0, name.length - 1) }}
        </button>
      </div>
    </div>

    <v-client-table :data="data" :columns="columns" :options="options">
      <template :slot="link" slot-scope="props">
        <a class="text-primary" @click="$emit('view', props.row)">{{ props.row[link] }}</a>
      </template>
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="props">
        <slot :name="slot" v-bind="props" />
      </template>
    </v-client-table>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    options: {
      type: Object,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    link: {
      type: String,
      default: ''
    },
    showCreate: {
      type: Boolean,
      default: true
    },
    dates: {
      type: Array,
      required: false,
      default: () => []
    }
  }
};
</script>
